module.exports = __webpack_public_path__ + "media/images/favicon-9861c24374bc4d74522c022dbd1428ca.ico";